export default __webpack_public_path__ + "static/cs-3-7ad19f878dc4ec69a0b55335e9f0cadd.png";